<template>
  <div>
    <h4>Land Payments</h4><br>

    <el-collapse v-if="this.isManager() && this.canAccess('finance')"  accordion value="history">

      <el-collapse-item v-if="!readOnly" title="Make Payment" name="pay">
        <landowner-payment :rowData="site" :site-id="site.id" />
      </el-collapse-item>

      <el-collapse-item title="Payment History" name="history">
        <tenancy-statement  :rowData="site" :site-id="site.id" />
      </el-collapse-item>

    </el-collapse>
    <div v-else>
      <tenancy-statement  :rowData="site" :site-id="site.id" />
    </div>

  </div>

</template>


<script>
import SiteMixins from '@/mixins/SiteMixins'

import LandownerPayment from '@/components/property/LandownerPayment'
import TenancyStatement from '@/components/property/TenancyStatement'

export default {

  mixins: [SiteMixins],

  components: {
    LandownerPayment,
    TenancyStatement
  },

  props: {
    rowData: {
      type: Object,
      required: true
    },
    editMode: {
      type: Boolean,
      default: false
    },

    readOnly: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      site: this.rowData
    }
  }
}
</script>



// WEBPACK FOOTER //
// SiteFinanceTenancy.vue?db8265bc